<script lang="ts" setup>
    import HeroScrollDown from '~/components/heroElements/HeroScrollDown.vue';
    import HeroBackground from '~/components/heroElements/HeroBackground.vue';
    import HeroMedia from '~/components/heroElements/HeroMedia.vue';

    const props = defineProps<{ blok: HeroComponentStoryblok }>();
    const { headlineContent, mediaSrc, mediaAlt, mediaContentType } = useHeroComponentContent(() => props.blok);
</script>

<template>
    <div
        v-editable="props.blok"
        class="hero-container"
    >
        <div class="hero-wrapper">
            <div class="content">
                <!-- eslint-disable vue/no-v-html -->
                <div
                    class="headline"
                    v-html="headlineContent"
                />
                <!-- eslint-enable vue/no-v-html -->

                <StoryblokComponentWrapper
                    v-for="item in props.blok.button"
                    :key="item._uid"
                    :blok="item"
                />
            </div>

            <HeroMedia
                :src="mediaSrc"
                :alt="mediaAlt"
                :content-type="mediaContentType"
                storage-key="hero-section-paused"
                clip-path-id="leaf"
                variant="leaf"
            >
                <template #clipPath>
                    <svg
                        aria-hidden="true"
                        viewBox="0 0 1 1"
                        style="fill-rule: evenodd; clip-rule: evenodd; stroke-linejoin: round; stroke-miterlimit: 2"
                    >
                        <defs>
                            <clipPath
                                id="leaf"
                                clipPathUnits="objectBoundingBox"
                            >
                                <path
                                    d="M0.505,1L-0,1L-0,0.489C-0,0.219 0.222,-0 0.495,0L1,0L1,0.511C1,0.781 0.778,1 0.505,1Z"
                                    style="fill: white; fill-rule: nonzero"
                                />
                            </clipPath>
                        </defs>
                    </svg>
                </template>
            </HeroMedia>
        </div>

        <HeroScrollDown />
        <HeroBackground />
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/hero-section/hero-section.scss';
</style>
